<!-- PE-6332 — Patient portal assistant (Triarq UI) -->
<div class="patient-chat" [class.patient-chat--open]="open">
  @if (open) {
    <section class="patient-chat__panel" role="dialog" aria-label="Portal assistant" aria-modal="true">
      <header class="patient-chat__header">
        <div class="patient-chat__brand">
          <span class="patient-chat__avatar" aria-hidden="true">
            <ion-icon class="patient-chat__avatar-icon" src="assets/svg/message-circle.svg"></ion-icon>
          </span>
          <div class="patient-chat__brand-text">
            <h2 class="patient-chat__title">Portal assistant</h2>
            <p class="patient-chat__status">
              <span class="patient-chat__status-dot" aria-hidden="true"></span>
              Online
            </p>
          </div>
        </div>
        <!-- PE-6332 — Start over -->
        @if (lines.length > 1) {
          <button
            type="button"
            class="patient-chat__text-button"
            [disabled]="sending"
            (click)="startOver()">
            Start over
          </button>
        }
        <button
          type="button"
          class="patient-chat__icon-button"
          (click)="toggle()"
          aria-label="Close assistant">
          <ion-icon class="patient-chat__close-icon" src="assets/svg/x.svg" aria-hidden="true"></ion-icon>
        </button>
      </header>

      <div class="patient-chat__suggestions" role="group" aria-label="Suggested questions">
        @for (suggestion of suggestions; track suggestion.question) {
          <button
            type="button"
            class="patient-chat__chip"
            [disabled]="sending"
            (click)="ask(suggestion.question)">
            {{ suggestion.label }}
          </button>
        }
      </div>

      <div #thread class="patient-chat__thread" role="log" aria-live="polite">
        @for (line of lines; track trackLine($index, line)) {
          <article
            class="patient-chat__line"
            [class.patient-chat__line--patient]="line.from === 'patient'"
            [class.patient-chat__line--assistant]="line.from === 'assistant'">
            @if (line.from === 'assistant') {
              <span class="patient-chat__line-avatar" aria-hidden="true">
                <ion-icon src="assets/svg/message-circle.svg"></ion-icon>
              </span>
            }
            <div class="patient-chat__bubble">
              <p class="patient-chat__text">{{ line.text }}</p>
              @if (line.route && line.routeLabel) {
                <button type="button" class="patient-chat__link" (click)="openRoute(line.route)">
                  {{ line.routeLabel }}
                  <ion-icon class="patient-chat__link-icon" src="assets/svg/chevron-right.svg" aria-hidden="true"></ion-icon>
                </button>
              }
            </div>
          </article>
        }

        @if (sending) {
          <div class="patient-chat__typing" aria-label="Assistant is typing">
            <span class="patient-chat__line-avatar" aria-hidden="true">
              <ion-icon src="assets/svg/message-circle.svg"></ion-icon>
            </span>
            <div class="patient-chat__typing-dots" aria-hidden="true">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        }

        @if (choices.length) {
          <div class="patient-chat__choices" role="group" aria-label="Booking choices">
            @for (choice of choices; track choice.id) {
              <button
                type="button"
                class="patient-chat__chip patient-chat__chip--choice"
                [disabled]="sending"
                (click)="choose(choice)">
                {{ choice.label }}
              </button>
            }
          </div>
        }
      </div>

      @if (showCaptcha) {
        <div class="patient-chat__captcha">
          <re-captcha [siteKey]="recaptchaSiteKey" (resolved)="onCaptcha($event)"></re-captcha>
        </div>
      }

      <form class="patient-chat__composer" (submit)="$event.preventDefault(); sendDraft()">
        <label class="patient-chat__label visually-hidden" for="patient-chat-input">Ask about the portal</label>
        <div class="patient-chat__row">
          <input
            id="patient-chat-input"
            class="patient-chat__input"
            type="text"
            maxlength="500"
            [value]="draft"
            [disabled]="sending"
            (input)="onDraftInput($event)"
            placeholder="Ask about appointments, forms, or records"
            autocomplete="off" />
          <button
            type="submit"
            class="patient-chat__send"
            [disabled]="sending || draft.trim().length === 0"
            [attr.aria-label]="sending ? 'Sending' : 'Send message'">
            @if (sending) {
              <span class="patient-chat__send-label">Sending</span>
            } @else {
              <ion-icon class="patient-chat__send-icon" src="assets/svg/send.svg" aria-hidden="true"></ion-icon>
            }
          </button>
        </div>
      </form>
    </section>
  }

  @if (!open) {
    <button
      type="button"
      class="patient-chat__launcher"
      (click)="toggle()"
      aria-expanded="false"
      aria-label="Open portal assistant">
      <ion-icon class="patient-chat__launcher-icon" src="assets/svg/message-circle.svg" aria-hidden="true"></ion-icon>
      <span class="patient-chat__launcher-label">Ask the portal</span>
    </button>
  }
</div>
